// =============================================================================
// jankGuards.ts — Orçamentos puros anti-hitch (GC / wipe / FX).
// Usados pelo Renderer no hot path e cobertos por testes sem bootar Pixi.
// =============================================================================

/** Partículas por death burst (normal / boss). */
export const DEATH_BURST_PARTS = { normal: 4, boss: 12 } as const;

/** Teto de partículas vivas no mundo. */
export const PARTICLE_CAP = 180;

/** Teto de números de dano flutuantes vivos. */
export const DMG_FLOAT_CAP = 24;

/** Máximo de death bursts (não-boss) por frame de render. */
export const BURSTS_PER_FRAME = 18;

/** Máximo de sfx de kill por frame (wipe não vira cascade de áudio). */
export const KILL_SFX_PER_FRAME = 6;

/** Quantas partículas cabem neste burst dado o orçamento restante do frame. */
export function deathBurstPartCount(opts: {
  big: boolean;
  particleAlive: number;
  particleCap: number;
  burstBudgetLeft: number;
}): number {
  if (opts.burstBudgetLeft <= 0) return 0;
  const room = opts.particleCap - opts.particleAlive;
  if (room <= 0) return 0;
  const want = opts.big ? DEATH_BURST_PARTS.boss : DEATH_BURST_PARTS.normal;
  return Math.min(want, room);
}

/** Morte merece FX visual? Só se o ponto estiver no retângulo de culling da câmera. */
export function deathFxOnScreen(
  x: number, y: number,
  minX: number, maxX: number, minY: number, maxY: number,
): boolean {
  return x >= minX && x <= maxX && y >= minY && y <= maxY;
}

/** Número de dano flutuante só se estiver na tela (evita alocar no wipe off-screen). */
export function dmgFloatAllowed(
  x: number, y: number,
  minX: number, maxX: number, minY: number, maxY: number,
  alive: number,
  cap: number,
): boolean {
  if (alive >= cap) return false;
  return deathFxOnScreen(x, y, minX, maxX, minY, maxY);
}
